import { RootState } from 'lib/core/data/reducer'
import { CartId, GiftMessage } from 'lib/types'
import { createSelector } from '@reduxjs/toolkit'
import { GiftMessageSlice } from './types'

export const getGiftMessage = (cartId: CartId) => createSelector(
  [
    (state: RootState) => state.quote.giftMessage[cartId ?? '']
  ],
  (giftMessageSlice) => {
    return createGiftMessage({ giftMessageSlice })
  }
)

const createGiftMessage = (deps: { giftMessageSlice: GiftMessageSlice }): GiftMessage | undefined => {
  const { giftMessageSlice } = deps
  if (!giftMessageSlice || !giftMessageSlice.data) {
    return
  }

  const { data: magentoGiftMessage, isFailure, isFetching, isSuccess } = giftMessageSlice
  const { items, message, recipient, sender } = magentoGiftMessage
  const isFirstLoad = isFetching && !isSuccess && !Object.prototype.hasOwnProperty.call(magentoGiftMessage ?? {}, 'message')

  const _data = {
    message: message ?? '',
    recipient: recipient ?? '',
    sender: sender ?? '',
    items: items?.map(item => {
      const { item_id: cartItemId, message, recipient, sender } = item
      return {
        cartItemId: cartItemId,
        message: message ?? '',
        recipient: recipient ?? '',
        sender: sender ?? ''
      }
    }) ?? []
  }

  return {
    isFirstLoad,
    isFetching,
    isSuccess,
    isFailure,
    data: _data
  }
}
